import React from "react";



export default function Contact() {




    return (
        <div class="component-body ">
            <div class="about-section">

                <h2>Facing any difficulty?</h2>
                <br></br>
            </div>
            <center>
                <h1 >Contact Us</h1>
                <br></br>
            </center>
            <div class="row">
                <div class="col">
                    <div class="card bg-info">

                        <div class="container text-light">
                            <h2>Development Team</h2>
                            <p class="title">System Admin</p>
                            <p>If you facing any system dificulties contact me through below </p>

                            <p>itpprojectsigiri@gmail.com</p>

                        </div>
                    </div>
                </div>

                <div class="col">
                    <div class="card bg-info">

                        <div class="container text-light">
                            <h2>Nisala Wishvanath</h2>
                            <p class="title">Managing Director</p>
                            <p>Contact managing director through this details.Only important things!!</p>
                            <p>nisalamanager@gmail.com</p>
                            <p>071- 5256255</p>
                        </div>
                    </div>
                </div>

                <div class="col">
                    <div class="card bg-info">

                        <div class="container text-light">
                            <h2>Sales Contact</h2>
                            <p class="title">Assistant Manager</p>
                            <p>Contact for sales assistant and information</p>
                            <p>071 - 85452648 </p>
                            <p>assistantman@gmail.com</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}